module.exports = __webpack_public_path__ + "img/PT47.f223aca1.png";